<template>
  <div class="help-page">
    <header class="help-header">
      <button class="help-back" type="button" :aria-label="$t('prizesBack')" @click="back">
        <span aria-hidden="true"></span>
      </button>
      <img v-if="type === '1'" src="../../static/images/faq_tc/faq.png" :alt="$t(titleKey)" />
      <img v-else src="../../static/images/faq_tc/tc.png" :alt="$t(titleKey)" />
    </header>

    <main class="help-board" :aria-label="$t(sectionKey)">
      <div class="help-board-title">{{ $t(sectionKey) }}</div>
      <div class="help-scroll">
        <div v-if="list" class="help-copy" v-html="list"></div>
      </div>
    </main>

  </div>
</template>

<script>
export default {
  name: 'HelpContentPage',
  props: {
    type: {type: String, required: true},
    titleKey: {type: String, required: true},
    sectionKey: {type: String, required: true}
  },
  data() {
    return {
      list: ''
    }
  },
  created() {
    this.getHome()
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    getHome() {
      this.$parent.$parent.loadModal(true)
      this.$api.post('/api/index/help', {type: this.type}, r => {
        this.$parent.$parent.returnCode(r, () => {
          this.list = localStorage.getItem('lang') === 'en' ? r.data.content : r.data.mm_content
          this.$parent.$parent.loadModal(false)
        })
      })
    }
  }
}
</script>

<style>
.help-page {
  box-sizing: border-box;
  width: 100%;
  max-width: 480px;
  height: 100vh;
  min-height: 0;
  margin: 0 auto;
  padding: 0.75rem 0 0.35rem;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #080e36 url(../../static/images/winner/winner_list_bg.jpg) no-repeat center center;
  background-size: 100% 100%;
  color: #fff;
  font-family: Atom-sans;
}
.help-header {
  position: relative;
  flex: 0 0 1.4rem;
  height: 1.4rem;
  margin-top: 0.35rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.help-header > img {
  display: block;
  width: 2.35rem;
  height: auto;
}
.help-back {
  position: absolute;
  left: 4.4%;
  top: 50%;
  width: 0.72rem;
  height: 0.72rem;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 0.22rem;
  background: rgba(255,255,255,.2);
  transform: translateY(-50%);
}
.help-back span {
  display: block;
  width: 0.2rem;
  height: 0.2rem;
  border-left: 0.08rem solid #fff;
  border-bottom: 0.08rem solid #fff;
  border-radius: 0.03rem;
  transform: translateX(0.04rem) rotate(45deg);
}
.help-board {
  box-sizing: border-box;
  flex: 1;
  min-height: 0;
  width: 91.2%;
  max-width: 7rem;
  margin: 0.1rem auto 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: url(../../static/images/faq_tc/text_bg.png) no-repeat center center;
  background-size: 100% 100%;
}
.help-board-title {
  box-sizing: border-box;
  flex: 0 0 0.96rem;
  width: 100%;
  padding: 0 0.18rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url(../../static/images/faq_tc/title_bg.png) no-repeat center center;
  background-size: 100% 100%;
  font-family: Atom-sans-bold;
  font-size: 0.29rem;
  line-height: 1.15;
  text-align: center;
}
.help-scroll {
  flex: 1;
  min-height: 0;
  margin: 0.25rem 0.08rem 0.05rem;
  padding: 0 0.28rem 0.3rem;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #3268ff transparent;
}
.help-scroll::-webkit-scrollbar {width: 0.05rem;}
.help-scroll::-webkit-scrollbar-thumb {border-radius: 0.05rem;background: #3268ff;}
.help-copy {
  color: #fff !important;
  font-size: 0.28rem;
  line-height: 1.48;
  overflow-wrap: break-word;
}
.help-copy * {
  color: #fff !important;
  font-size: inherit !important;
  line-height: inherit !important;
}
.help-copy > :first-child {margin-top: 0;}
.help-copy p {margin: 0 0 0.35rem;}
.help-copy h1, .help-copy h2, .help-copy h3, .help-copy h4 {
  margin: 0.42rem 0 0.25rem;
  color: #fff;
  font-family: Atom-sans-bold;
  font-size: 0.3rem !important;
  line-height: 1.35 !important;
}
.help-copy strong, .help-copy b {font-family: Atom-sans-bold;}
.help-copy ul, .help-copy ol {margin: 0 0 0.35rem;padding-left: 0.38rem;}
.help-copy li {margin-bottom: 0.12rem;}
.help-copy img {max-width: 100%;height: auto;}
.help-copy a, .help-copy a * {color: #3ce7ff !important;overflow-wrap: anywhere;}
@media (min-width: 481px) {
  .help-page {box-shadow: 0 0 0 100vmax #0d123b;}
}
</style>



// WEBPACK FOOTER //
// src/components/HelpContentPage.vue